import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import PortfolioCard from "./PortfolioCard";
import { toAbsoluteUrl } from "../utils/url";

function Portfolio() {
  // Removed unused state variables and animation objects
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Debug logging
  console.log('Portfolio component mounted');
  console.log('Current URL:', window.location.href);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Try primary collection 'projects' first (ordered by createdAt desc)
        let rows = [];
        try {
          const q1 = query(collection(db, "projects"), orderBy("createdAt", "desc"));
          const snap1 = await getDocs(q1);
          rows = snap1.docs.map((d) => ({ id: d.id, ...d.data() }));
        } catch (e1) {
          // ignore and fallback below
        }

        // Fallback: try 'portfolio' collection (without order for compatibility)
        if (!rows || rows.length === 0) {
          try {
            const snap2 = await getDocs(collection(db, "portfolio"));
            rows = snap2.docs.map((d) => ({ id: d.id, ...d.data() }));
          } catch (e2) {
            // final fallback: empty
            rows = [];
          }
        }

        if (!mounted) return;
        const mapped = rows.map((data) => ({
          id: data.id,
          title: data.title || "Untitled",
          image: data.imageUrl || data.image || "",
          link: data.liveLink ? toAbsoluteUrl(data.liveLink) : "#",
          category: (Array.isArray(data.tags) && data.tags[0]) || "Project",
          tech: Array.isArray(data.tech) ? data.tech : [],
        }));
        // Incrementally render items
        setItems([]);
        let first = true;
        for (const item of mapped) {
          if (!mounted) break;
          setItems((prev) => [...prev, item]);
          if (first) {
            first = false;
            setLoading(false);
          }
          await new Promise((r) => setTimeout(r, 0));
        }
      } catch (e) {
        console.error("Failed to load projects:", e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  // Removed unused categories calculation
  return (
    <section id="portfolio" className="py-14 sm:py-16 lg:py-20 bg-white text-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center lg:items-start justify-center lg:justify-between mb-8 sm:mb-10 text-center lg:text-left">
          <div className="space-y-2">
            <p className="text-sm font-medium text-gray-500 flex items-center justify-center lg:justify-start gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: "rgb(232, 51, 16)" }} />
              Portfolio
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold tracking-tight leading-tight">
              My Latest <span style={{ color: "rgb(232, 51, 16)" }}>Projects</span>
            </h2>
          </div>
        </div>

        {loading && (
          <div className="w-full h-1 mb-4 overflow-hidden bg-transparent">
            <div className="progress-bar" />
          </div>
        )}

        {items.length === 0 && !loading ? (
          <div className="text-sm text-gray-500">No projects found.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {items.map((p) => (
              <PortfolioCard key={p.id} project={p} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Portfolio;
